import instance from 'shared/helpers/axios';
import { catchError } from 'shared/helpers/catchError';
import { ICountryCodesResponse } from './types';

export const getCountryCodes = async () => {
  try {
    const { data } = await instance.get<ICountryCodesResponse>(
      '/dictionaries/country_codes',
    );
    return data;
  } catch (error) {
    catchError(error);
  }
};
